<template>
    <div class="list">
        <NavBar></NavBar>
        <!-- 如果一开始没绑定成功的话先出来这个div -->
        <div v-if="isShow" style="margin-top:60px">
            <van-empty class="custom-image" :image="require('@/assets/Image/custom-empty-image.png')" description="您尚未绑定房屋,请先进行绑定。" />
        </div>
        <!-- 如果一开始绑定成功的话就直接让他显示那好几条 -->
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list style="margin-bottom:50px" v-model:loading="loading" v-model:error="error" error-text="请求失败，点击重新加载" :finished="finished" @load="onLoad" >
                <div class="HouseCard" v-for="item in list" :key="item" @click="skipDetail(item)">
                    <van-col span='24' style="font-size:14px;font-weight:bold">{{item.houseSite}}</van-col>
                    <van-col span='24' style="font-size:12px;color:gray;margin:6px 0">房屋交易业务编号：{{item.contractNo}}</van-col>
                    <van-row style="margin-top:15px">
                        <van-col span='8' style="text-align:center">
                            <van-col span='24' style="font-size:14px;font-weight:bold;line-height:28px">{{item.struArea}}</van-col>
                            <van-col span='24' style="font-size:12px;color:gray;margin-top:6px">建筑面积(㎡)</van-col>
                        </van-col>
                        <van-col span='8' style="text-align:center">
                            <!-- <van-col span='24' style="font-size:14px;font-weight:bold">{{item.dueState==1?'足额':item.dueState==2?'多交':item.dueState==3?'少交':item.dueState==4?'未交':item.dueState==5?'免交':''}}</van-col> -->
                            <!-- 足额的叫已交存 其他都是代缴存 -->
                            <van-col span='24' style="font-size:14px;font-weight:bold;line-height:28px">{{item.dueState==1||item.dueState==2||item.dueState==5?'已交存':item.dueState==3||item.dueState==4?'待交存':''}}</van-col>
                            <van-col span='24' style="font-size:12px;color:gray;margin-top:6px">交存状态</van-col>
                        </van-col>
                        <van-col span='8' style="text-align:center">
                            <van-col span='24' style="font-size:17px;font-weight:bold;color:blue;line-height:28px">{{item.fundBal}}</van-col>
                            <van-col span='24' style="font-size:12px;color:gray;margin-top:6px">账户余额(元)</van-col>
                        </van-col>
                    </van-row>
                </div>
            </van-list>
        </van-pull-refresh>
        <!-- 查询绑定的弹框 -->
        <van-action-sheet v-model:show="quickShow" title="查询房屋坐落" :style="{ height: '70%' }">
            <div class="content contentSon">
                <van-field v-model="scanQRCodeValue" :border='false' center clearable placeholder="请输入房屋交易业务编号">
                <template #button>
                    <van-button size="small" icon="scan" type="primary" @click="scanQRCode"></van-button>
                </template>
                </van-field>
                <van-col span='24' style="font-size:12px;color:gray;margin-top:10px">什么是交易业务编号：业主进行房屋交易时获得的交易业务编号，交易成功后会记录在房屋交易合同中。</van-col>
                <van-col span='24' style="text-align:center;margin-bottom:100px;margin-top:10px">
                    <van-image width="16rem"  fit="contain" :src="require('../../assets/Image/crtc.jpg')"/>
                </van-col>
                <van-col span='24'></van-col>
            </div>
            <div class="bottom_flex" v-show="hidshow">
                <van-row  class="secondFlex">
                    <van-col :span="24" class="owerviting">
                        <van-checkbox style="width:50px" v-model="checked" >
                        </van-checkbox>
                        <span>
                            我同意威海市南海维修资金使用我所提交的信息用于房屋数据校验。
                            <span style="color:#428bca" @click="openArgeement">《隐私协议》</span>
                        </span>
                    </van-col>
                </van-row>
                <div class="flexed">
                    <van-button color="#e1251b"  size="normal" :disabled='!checked' @click="NextThen">下一步</van-button>
                </div>
            </div>
        </van-action-sheet>
        <!-- 固定button按钮 -->
        <div class="FlexBtn">
            <div style="padding:10px">
                <van-button block icon="search" color="#e1251b" size="normal" @click="openBinding">房屋绑定</van-button>
            </div>
        </div>
        <!-- 操作说明弹框 -->
        <van-dialog v-model:show="caozuos" title="隐私协议" :lock-scroll='false' show-cancel-button :show-confirm-button='false'>
            <!-- <div style="padding:10px 15px;font-size:14px;height:300px;overflow:auto">
                {{}}
            </div> -->
            <div style="padding:10px 15px;font-size:14px;height:300px;overflow:auto">
                南海新区维修资金服务平台非常重视保护您的隐私。

为方便您登录、使用相关服务，以及为您提供更个性化的用户体验和服务，您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望
通过本隐私政策向您说明，在使用南海新区维修资金服务平台（以下统称“南海新区维修资金服务平台)时，我们如何收集、使用、储存和披露您的信息，以及我们为您提供的访间、更新、控制和保护这些信息的方式。本隐私政策与您所使用的南海新区维修资金服务平台信息及个人隐私信息相关，希望您仔细阅读。
您阅读并同意本隐私政策后，即意味着您已经同意我们按照本隐私政策收集、使用、储存和披露您的相关信息，以及向您提供的控制和保护措施。

一、适用范围

1.1本隐私政策适用于南海新区维修资金服务平台的所有服务，服务包括向您提供页面浏览、网站登录服务，以及通过南海新区维修资金服务平台向您提供的技术服务等。1.2本隐私政策中的“信息特指第二条所收集的信息。

二、信息收集范围

2.1	为完成南海新区维修资金服务平台账户的注册、管理、实名认证等必要活动，您需要提交真实、合法、有效的信息，包括但不限于您的姓名、身份证号码、身份证有效期、联系电话、人脸生物信息、微信昵称、头像等。
2.2	您使用本服务时，可能收集已经经过您授权获取或主动填写的如下信息：
2.2.1	日志信息指您用我们的服务时，系统可能通过自动采集的技术信息，包括：
•	设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码。
•	有关您曾使用的移动应用和其他软件的信息，以及您曾经使用该等移动应用和软件的信息。
•	您通过我们的服务进行通讯的信息，例如曾通讯的帐号。
•	您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。
2.2.2位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：
•	您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息。
•	您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息。
•	您可以通过关闭定位功能，停止对您的地理位置信息的收集。
2.3	如果您需要使用部分可选的功能或服务如公积金、社保、公共交通、税务、户政、公共服务等，您还应该提供使用该功能或服务所必须的信息，如性别、出生日期、出生地、户籍所在地、民族等。
2.4	如果您需要在线上申请线下交付或进行产品测试，为履行所必需，您应提供联系人、联系方式、地址等必要信息。

三、如何收集信息
3.1	我们通过您主动提交，以及在您使用我们的服务过程中产生相应的记录等方式收集您的信息。
3.2	我们可能会通过数据埋点和其他相关技术收集和使用您的信息。我们使用数据埋点的具体用途包括：
•	分析您使用我们服务的清况，以便为您提供更加周到的个性化服务，包括定制化页面、推荐等服务。
3.3	通过南海新区维修资金服务平台数据埋点记录的有关信息，将适用本隐私政策。

四、信息使用
为了向您提供更加优质、便捷、安全的服务，在符合相关法律法规的前提下，我们可能将收集的信息用作以下用途：
•	向您提供服务（如实名认证信息、用来接受验证码的手机号，是继续获得服务的前提）。
•	满足您的个性化需求。例如，语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应。
•	服务优化和开发。例如，我们会根据南海新区维修资金服务平台系统响应您的需求时产生的信息，优化我们的服务。
•	保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或南海新区维修资金服务平台相关协议、规则的清况，我们可能使用您的帐号信息、并整合设备信息、有关网络日志以及我们关联公司、合作伙伴分享的信息，来判断您账户风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施。例如，我们会将您的信息用于身份验证、安全防范、投诉处理、纠纷协调、诈骗监测等用途。您在使用安全功能或其他类似服务时，我们会对恶意程序或病毒进行检测，或为您识别诈骗信息。
•	向您提供与您更加相关的服务。例如，向您提供您可能感兴趣的类似功能或服务等。
•	邀请您参与有关我们产品和服务的调查。
•	其他可能需要使用收集的信息的相关场景，如果使用场景与初始场景无合理的关联性，我们会在使用信息前重新征得您的同意。

五、信息共享、转让、披露
5.1	信息共享
我们不会与其他组织和个人共享您的用户信息，但以下情况除外：
5.1.1	在获取明确同意的清况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；
5.1.2	在法定清形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；
5.1.3	为了促成办理服务或协助解决争议，某些情况下只有共享您的用户信息，
才能促成办理或处理您与他人的纠纷或争议。
5.1.4	与授权合作伙伴共享：我们可能委托受信赖的合作伙伴来提供服务（如人脸识别服务），因此我们可能会与合作伙伴共享您的某些用户信息，以提供更好的客户服务和优化用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息。我们的合作伙伴无权将共享的用户信息用于任何其他用途。
目前，我们的授权合作伙伴包括如下类型：供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。
对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理用户信息。
5.2	转让
我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：
5.2.1在获取明确同意的清况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息。
5.3	披露
未经您同意，我们不会与任何无关第三方分享您的信息，以下情形除外：
5.3.1.	我们可能将您的信息与我们的关联公司、第三方服务提供商、承包商及代理分享，仅用作下列用途：
•	提供“二、信息收集范围”中的相应功能或服务所必需，以及出于“四、信息使用“中的部分所述目的所必需。
如我们与任何上述第三方分享您的信息，我们将努力确保第三方在使用您的信息时遵守本声明及我们要求其遵守的其他适当的保密和安全措施。
5.3.2.	随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、
收购、资产转让或类似的交易，您的信息有可能作为此类交易的—部分而被转移。我们将遵守相关法律法规的要求，在转移前通知您，确保信息在转移时的机密性，以及变更后继续履行相应责任和义务。
5.3.3.	我们还可能因以下原因而披露您的信息：
•	遵守适用的法律法规等有关规定。
•	遵守法院判决、裁定或其他法律程序的规定。
•	遵守相关政府机关或其他有权机关的要求。
•	我们有理由确信需遵守法律法规等有关规定。
•	为执行相关服务协议或本隐私政策、维护社会公共利益、处理投诉／纠纷，保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。
•	经过您合法授权的情形。
如我们因上述原因而披露您的信息，我们将在遵守法律法规相关规定及本声明的基础上及时告知您。

六、信息存储

6.1	南海新区维修资金服务平台收集的有关您的信息保存在南海新区维修资金服务平台位于中国大陆的服务器，微信本身不会留存您的任何信息。
6.2	通常，我们仅在为您提供服务期间保留您的信息，保留时间不会超过满足相关使用目的所必须的时间。
但在下列情况下，且仅出于下列情况相关的目的，我们有可能需要较长时间保留您的信息或部分信息：
•	遵守适用的法律法规等有关规定。
•	遵守法院判决、裁定或其他法律程序的要求。
•	遵守相关政府机关或其他有权机关的要求。
•	我们有理由确信需遵守法律法规等有关规定。
•	为执行相关服务协议或本隐私政策、维护社会公共利益、处理投诉／纠纷，保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。

七、信息安全
如果您拥有南海新区维修资金服务平台其他账号，在特定场景下，您的南海新区维修资金服务平台账号的个人信息（身份证、手机号、姓名）可能会与您在南海新区维修资金服务平台拥有的其他账户信息相关联。例如，您使用微信支付注册南海新区维修资金服务平台账号。
7.1	我们努力保障信息安全，以防信息的丢失、不当使用、未经授权阅览或披露。
•	我们使用各种安全技术以保障信息的安全。例如，我们将通过服务器多备份、密码加密等安全措施，防止信息泄露、毁损、丢失。
•	我们建立严格的管理制度和流程以保障信息的安全。例如，我们严格限制访间信息的人员范围，并进行审计，要求他们遵守保密义务。
•	我们重视信息安全合规工作，并通过众多国际和国内的安全认证，如网络安全等级保护认证等，以业界先进的解决方案充分保障您的信息安全。
但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网环境下，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，按照《国家网络安全事件应急预案》等有关规定及时上报，并以发送邮件、推送通知、公告等形式告知您相关情况，并向您给出安全建议。
7.2	为更有效的保障您的信息安全，我们也希望您能够加强自我保护意识。我们仅在南海新区维修资金服务平台直接导致您个人信息泄露的范围内承担责任，因此，请您妥善保管您的账号及密码信息，避免您的个人信息泄露。南海新区维修资金服务平台账户及微信账号均有安全保护功能，但您也需要妥善保护自己的个人信息，除非您判断认为必要的情形下，不向任何第三人提供您的账号密码等个人信息。

八、访问与控制

8.1	您可以在使用我们服务的过程中，访间、修改和删除您的相关信息。您访问、修改和删除信息的方式将取决于您使用的具体服务。
8.2	如您发现我们违反法律法规的规定或者双方的约定收集、使用您的信息，您可以要求我们删除。如您发现我们收集、存储的您的信息有错误的，且无法自行更正的，您也可以要求我们更正。
8.3	在访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障账户安全。请您理解，由于技术所限、基于法律法规要求，您的某些请求可能无法进行响应。
8.4	基于法律法规要求、保障信息安全等正当事由，您的部分信息可能无法访间、修改和删除。
8.5	您可以自行选择撤回对某些非基本功能或服务对您信息处理的同意，并通过联系客服的方式选择注销南海新区维修资金服务平台账号。
8.6	如您对上述权利实现存在疑间，可以根据“十、与我们联系”中的相关联系方式与我们取得联系。

九、隐私政策的更新

我们可能适时修订本隐私政策的条款，该等修订构成本《隐私政策》的—部分。如可能造成您在本隐私政策下权利的实质减少或扩大收集、使用信息的范围等重要规则变更时，我们将在修订生效前通过在主页上显著位置弹窗提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本隐私政策的约束。

十、与我们联系

如您对本政策或其他相关事宜有疑间，您可以通过【账户中心-联系我们】查询并电话联系我们。我们将尽快审核所涉间题，并在验证您的用户身份后予以回复。
            </div>
    </van-dialog>
        <!--  -->
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk'
    import VueCookie from 'vue-cookie'
    export default {
        data(){
            return{ 
                contents:`<p><b></b>威海市南海新区物业专项维修资金一次性表决使用程序<br></p><p><o:p>&nbsp;</o:p></p><p>一、一般规定</p><p>1.1物业专项维修资金一次性表决使用应按申请受理、现场勘查、业主表决、审核、公示、拨款的程序办理。</p><p>1.2一次性表决使用物业专项维修资金应当具备下列条件:</p><p>1.2.1表决范围内全体业主受益</p><p>1.2.2一次性表决使用物业专项维修资金,当专有部分占建筑物总面积1/3以下的业主且占总人数1/3(以下简称“异议表决")以下的业主表决不同意，则本次表决通过。</p><p>二、表决限制</p><p>2.1身份限制</p><p>2.1.1表决人应为该维修项目表决范围内房屋的当前业主，业主表决前有义务提供表决房屋的所有权以完成业主绑定认证，无法提供房屋所有权证明的无法参与表决。</p><p>2.1.2表决范围内每个房屋最多仅占一票表决权，每个房屋当前业主有权行使表决操作。当房屋包含多个业主时，仅允许最先参与表决（最先点击提交表决意见）的业主参与表决。</p><p>2.2时间限制</p><p>2.2.1维修资金表决分为公示期、表决期、表决结束三个阶段。</p><p>2.2.2公示期可以查看表决详情，但不可提交表决意见。</p><p>2.2.3表决期可以提交一次性表决意见，但不可修改。</p><p>2.2.4表决结束后进行计票并最终形成表决结果（通过、不通过），仅可查看表决详情，如尚未提交表决意见的，则不可继续提交。</p><p>三、异议反馈</p><p>3.1当表决结束后，其他房屋业主对该次表决有异议的，应当在表决结束后5个工作日内联系南海维修资金（详情见账户中心-联系我们），填报申请材料，工作人员将在审核后反馈意见。</p><p>3.2当表决结束后，房屋共有业主对该次表决意见有异议的，应当在表决结束后5个工作日内联系南海维修资金（详情见账户中心-联系我们），征得该房屋所有共有业主同意并填报申请材料，工作人员将在审核后反馈意见。</p>`,
                caozuos:false,
                error:false,
                refreshing:false,
                checked:false,
                loading:false,
                finished:false,
                quickShow:false,
                list:[],
                isShow:false,
                screenHeight: document.documentElement.clientHeight,//一个是实施的高度一个是手机整体的高度 底下判断监听
                originHeight: document.documentElement.clientHeight,
                hidshow:true,  //显示或者隐藏footer
                scanQRCodeValue:''
            }
        },
        /**
         * 在切换路由或者关闭路由的时候关闭预览图片的遮罩
         */
        beforeRouteLeave(to,from,next){
            // this.$nextTick(()=>{
                if(this.quickShow){
                    this.quickShow = false
                    next(false)
                }else{
                    next(true)
                }
                //  if(this.quickShow){
                //     this.quickShow = false
                //     next(false)
                // }else 
                // console.log(to)
                // if(to.name=='index'){
                //     next(true)
                // }else{
                //     // this.$router.push({path:'/'})
                //     next('/')
                // //    return next({path:'/FaceRecognition'})
                // }
                // if(to.fullPath=='/'){
                //     next(true)
                // }else{
                //     next('/')
                // }
                // if(to.name=='我的表决'){
                //     next({path:'/'})
                // }else{
                //     next(true)
                // }
                // if(to.name=='index'){
                //     next(true)
                // }else{
                    
                // }
            // })
        },
        // beforeRouteLeave(to,from,next){
        //     this.$nextTick(()=>{
        //         if(this.quickShow){
        //             this.quickShow = false
        //         }
        //     })
        //     next()
        // },
        mounted(){
            let self = this;
            window.onresize = function() {
                return (function(){
                    self.screenHeight = document.documentElement.clientHeight;
                })()
            }
        },
        watch:{
            /**
             * 监听一下高度
             */
            screenHeight (val) {
                if(this.originHeight > val + 100) {        //加100为了兼容华为的返回键
                    this.hidshow = false;
                }else if(this.originHeight == val ){
                    this.hidshow = true
                }else{
                    this.hidshow = true;
                }
            }
        },
        methods:{
            openBinding(){
                this.checked = false
                this.quickShow = true
                this.scanQRCodeValue = ''
                // this.$router.push({
                //     path:'/HouseSearch'
                // })
            },
            /**
             * 扫一扫
             */
            scanQRCode(){
                console.log('点击扫一扫')
                let _this=this;
                wx.scanQRCode({
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    // scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {
                        _this.scanQRCodeValue=res.resultStr.split(',')[1];
                        console.log("扫描结果为：" + res.resultStr);
                    }
                });
            },
            /**
             * 加载绑定接口
             */
            onLoad(){
                //发送ajax调取接口
                console.log('123456')
                let data = {
                    openId:VueCookie.get('openid'),
                    // openId:'okLBP6Pdn1tAK_8OSPl6Zf9uOsN4',
                    // openId:'o5AgcxKDu14LYiSrhGBzj_rMu7ZM',
                    pageNum:1,
                    pageSize:100
                }
                this.$postQuery('/WeChat/getBindHouseListByOpenId', data)
                .then((response) => {
                    // console.log(response,'111111')
                    if (this.refreshing) {
                        this.list = [];
                        this.refreshing = false;
                    }
                    if(response.code==200){
                        if(response.data.list.length==0){
                            this.isShow = true;
                            this.loading = false
                            if (this.list.length >= response.data.list.length) {
                                this.finished = true;
                            }
                        }else{
                            this.list = response.data.list
                            this.loading = false
                            if (this.list.length >= response.data.list.length) {
                                this.finished = true;
                            }
                        }
                    }else{
                        this.error = true;
                        this.loading = false
                    }
                    // if(response.data.list.length==0){
                    //     this.isShow = true
                    // }
                }) 
                .catch(()=>{
                    this.error = true;
                    this.loading = false
                })
            },
            /**
             * 刷新
             */
            onRefresh(){
                // 清空列表数据
                this.finished = false;
                //重新加载数据
                this.loading = true;
                this.onLoad();
            },
            openThis(){
                this.$dialog.confirm({
                    message: '系统检测到该房屋交易状态已改变，请选择操作。',
                    theme: 'round-button',
                    confirmButtonText:'删 除',
                    cancelButtonText:'重新绑定'
                })
                .then(() => {
                        // on confirm
                    console.log('删除')
                })
                .catch(() => {
                    console.log('重新绑定')
                    this.quickShow = true
                        // on cancel
                });
            },
            /**
             * 点击事件   如果出现没有的数据(这里用灰色卡片代替)那么没有的数据是不能点进去交存的，有用的数据才能点进去交存 有用没有是根据一个状态来判断的
             */
            skipDetail(item){
                console.log('111111111122222222223')
                this.$router.push({
                    path:'/HouseDetails',
                    query:{
                        houseSite:item.houseSite,
                        fundBal:item.fundBal,
                        contractNo:item.contractNo,
                        struArea:item.struArea,
                        ratio:item.ratio,
                        houseAttr:item.houseAttr,
                        dueState:item.dueState,
                        amountDue:item.amountDue,
                        houseId:item.houseId
                    }
                })
                // if(item.state==0){
                //     this.$router.push({
                //         path:'/HouseDetails',
                //         query:{
                //             a:item.a,
                //             b:item.b,
                //             c:item.c,
                //             d:item.d,
                //             e:item.e,
                //             f:item.f
                //         }
                //     })
                // }else if(item.state==1){
                //     console.log('1111111')
                //     this.openThis()
                // }
                
            },
            /**
             * 点击下一步
             */
            NextThen(){
                if(this.scanQRCodeValue==''){
                    this.$toast('请输入交易业务编号')
                    return
                }else{
                    let data = {
                        openId:VueCookie.get('openid'),
                        // openId:'okLBP6Pdn1tAK_8OSPl6Zf9uOsN4',
                        contractNo:this.scanQRCodeValue,
                        // openId:'o5AgcxDoREhPpdd0wzkSYvfnSKmQ',
                    }
                    this.$postQuery('/WeChat/getBindHouse', data).then((response)=>{
                        if(response.data.data==200){
                            this.obj = response.data.obj
                            this.$router.push({
                                path:'/HouseSearch',
                                query:{
                                    obj:JSON.stringify(response.data.obj),
                                    contractNo:this.scanQRCodeValue,
                                }
                            })
                        }else{
                            this.$toast(response.data.message)
                        }
                    })
                    // this.$router.push({
                    //     path:'/HouseSearch',
                    //     query:{
                    //         contractNo:this.scanQRCodeValue,
                    //         openId:'o5AgcxDoREhPpdd0wzkSYvfnSKmQ',
                    //     }
                    // })
                }
                this.quickShow = false
            },
            openArgeement(){
                this.caozuos = true
            }
        },
        created(){
            
        }
    }
</script>

<style scoped>
.list {
    margin-top: 46px;
}
.contentSon{
  padding: 16px 16px 16px;
}
.contentSon .van-field__body{
  border: 1px solid #e0e0e0;
  padding-left:10px;
}
.contentSon .van-button--primary{
  background-color: transparent;
  border: 0;
  color: black;
  font-size: 16px;
}
.contentSon .van-cell{
  padding: 0;
}
.flexBottom{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.flexBottom .house_button{
  margin: 10px;
}
.flexBottom  .house_button .van-button,.content_button .van-button{
  padding: 3px 15px;
  width: 100%;
}
.house_list{
    margin-bottom: 200px;
}
.house_list .card1{
  padding: 5px 20px;
  font-size: 12px;
  margin: 0 auto;
  box-shadow: 0 8px 12px #ebedf0;
  margin-top: 8px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
}
.house_list .card2{
  padding: 5px 20px;
  font-size: 12px;
  margin: 0 auto;
  box-shadow: 0 8px 12px #ebedf0;
  margin-top: 8px;
  border-radius: 5px;
  border: 1px solid #e0e0e0;
  background-color: gray;
  color: white;
}
.house_list .van-col{
  margin-top:10px;
  margin-bottom:10px;
}
.house_list{
  overflow: auto;
}
.house_site,.house_area,.house_money{
  font-size: 14px;
  font-weight: bold;
}
.content_left,.content_right{
  margin: 0 !important;
  text-align: center;
}
.custom-image>>>.van-empty__image {
    width: 100px;
    height: 100px;
}
.FlexBtn{
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.7);
}
.bottom_flex{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-top: 10px;
    background-color: rgba(255, 255,255, 0.9);
}
.secondFlex{
    padding: 0 10px;
}
.owerviting{
    font-size: 13px;
    line-height: 18px;
    display: flex;
    align-items: center;
}
.flexed{
  margin: 10px;
}
.flexed .van-button,.content_button .van-button{
  padding: 3px 15px;
  width: 100%;
}
.HouseCard{
    border: 1px solid #e0e0e0;
    margin: 10px;
    padding: 15px 10px;
    box-shadow: 0 8px 12px #ebedf0;
    border-radius: 5px;
}
</style>